import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { ButtonLoader } from "Components";
import { newAuthService } from "Service/Axios";
import { getGlobalSkillsUrl, saveUserProfileUrl } from "Constant/api";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";
import { Validator } from "Utils/validator";

export const SkillsModal = ({ show, skillsData, toggle, fetchData }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [skillLoading, setSkillLoading] = useState(false);
  const [skillList, setSkillList] = useState([]);
  const [search, setSearch] = useState("");
  const [skills, setSkills] = useState([]);
  const [skillError, setSkillError] = useState("");

  const skillListWithSearch = useMemo(() => {
    if (search.length > 0) {
      return skillList.filter((skill) =>
        skill.name.toLowerCase().includes(search.toLowerCase())
      );
    }
    return [];
  }, [skillList, search]);

  useEffect(() => {
    if (skillsData) {
      setSkills(skillsData);
    }
  }, [skillsData]);

  // Fetch all skils
  const fetchSkillList = async () => {
    setSkillLoading(true);
    const payload = {};
    const response = await newAuthService(getGlobalSkillsUrl, "POST", payload);
    setSkillList(response.data);
    setSkillLoading(false);
  };

  useEffect(() => {
    fetchSkillList();
  }, []);

  const handleSearchSkills = (e) => {
    setSearch(e.target.value);
  };

  const handleChangeSkill = (skill) => {
    const alreadySelected = skills.find((item) => item.gid === skill.gid);

    setSearch("");
    setSkillError("");
    if (alreadySelected) {
      setSkills(skills.filter((item) => item.gid !== skill.gid));
    } else {
      setSkills([...skills, skill]);
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      let isValid = true;

      if (!Validator.hasMultiple(skills)) {
        setSkillError(t("common.messages.error.viewProfile.skills.blank"));
        isValid = false;
      }

      resolve(isValid);
    });
  };

  const onSaveAboutMe = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      try {
        const payload = {
          key: VIEW_PROFILE_SECTIONS.skills,
          [VIEW_PROFILE_SECTIONS.skills]: skills,
        };

        setLoading(true);
        const response = await newAuthService(
          saveUserProfileUrl,
          "POST",
          payload
        );
        if (response.status) {
          toast.success(
            t("common.messages.notification.success.profileUpdated")
          );
          fetchData();
          toggle();
        } else {
          toast.error(response.message);
        }
      } catch {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={toggle} className="highlightsModal">
      <Modal.Header closeButton>
        <Modal.Title className="text-md font-medium">
          {t("auth.viewProfile.editSkills")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12 col-sm-12 col-12">
            <div className="position-relative">
              <input
                type="text"
                className="form-control form-control-lg rounded-lg"
                id="search"
                placeholder={t("common.placeHolder.addSkill")}
                autoComplete="off"
                name="search"
                value={search}
                onChange={handleSearchSkills}
              />
              {skillError && <p className="text-danger">{skillError}</p>}
              {skillListWithSearch && skillListWithSearch.length > 0 && (
                <ul className="skils-list list-unstyled shadow">
                  {skillListWithSearch.map((item) => (
                    <li key={item.gid}>
                      <a
                        onClick={() =>
                          handleChangeSkill({ gid: item.gid, name: item.name })
                        }
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              )}              
            </div>

              <div className="mt-2 d-inline-flex flex-wrap gap-1">
                {skills.map((skill) => (
                  <span key={skill.gid} className="selected-skill-badge ps-3 pe-0 py-0 text-xs font-medium text-dark rounded-pill bg-grey-100 d-inline-flex justify-content-center align-items-center">
                    {skill.name}
                    <button onClick={() => handleChangeSkill(skill)} className="border-0 bg-transparent w-6 h-6 d-flex justify-content-center align-items-center">
                      &times;
                    </button>
                  </span>
                ))}
              </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={toggle}>
          {t("common.button.cancel")}
        </Button>
        {loading ? (
          <ButtonLoader />
        ) : (
          <Button
            variant="primary"
            onClick={onSaveAboutMe}
            disabled={skillLoading}
          >
            {t("common.button.save")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
